// Ortak visit etiketleri. Excel dosyaları bu Türkçe metinlerle yazılır; ekranda
// visitModal.todo.items çevirisi varsa o gösterilir.

/** Yapılacaklar listesi anahtarlarının Türkçe karşılıkları (Excel başlıkları). */
export const TODO_LABELS = {
  pre_patientCalled: 'Hasta arandı mı?',
  pre_nurseTransferArranged: 'Hemşire transferi ayarlandı mı?',
  pre_courierArranged: 'Kurye ayarlandı mı?',
  pre_hospitalApproval: 'Hastane onayı alındı mı?',
  pre_nurseEquipmentReady: 'Hemşire ekipmanı hazır mı?',
  pre_accommodationPlanned: 'Konaklama planlandı mı?',
  patientConsent: 'Hasta onamı alındı mı?',
  protocolUpdate: 'Protokol güncellemesi yapıldı mı?',
  kvkkApproval: 'KVKK onayı alındı mı?',
  visitNumberCheck: 'Visit numarası kontrol edildi mi?',
  projectCheck: 'Proje kontrolü yapıldı mı?',
  patientInformed: 'Hasta bilgilendirildi mi?',
  sampleCollection: 'Numune toplama yapıldı mı?',
  sampleShipping: 'Numune kargolama yapıldı mı?',
  sourceDocumentsShared: 'Ziyaret sırasında doldurulan kaynak dökümanlar çalışma ekibi ile e-posta olarak paylaşıldı mı?',
  transferForm: 'Transfer formu dolduruldu mu?',
  documentShipping: 'Kaynak dökümanlar kargolandı mı?',
  sourceDocuments: 'Kaynak dökümanlar hazırlandı mı?',
  sourceDocumentsApproval: 'Kaynak dökümanlar onaylandı mı?',
  workflowCheck: 'İş akışı kontrolü yapıldı mı?',
  medicationCheck: 'İlaç kontrolü yapıldı mı?',
  equipmentCheck: 'Ekipman kontrolü yapıldı mı?',
  medicationAdministered: 'İlaç uygulaması yapıldı mı?',
  adverseEventCheck: 'Advers olay kontrolü yapıldı mı?',
  vitalSignsRecorded: 'Vital bulgular kaydedildi mi?',
  labSamplesCollected: 'Laboratuvar örnekleri toplandı mı?',
  concomitantMedsReviewed: 'Eşzamanlı ilaçlar gözden geçirildi mi?',
  inclusionExclusionCheck: 'Dahil/Hariç kriterleri kontrol edildi mi?',
  informedConsentSigned: 'Bilgilendirilmiş onam imzalandı mı?',
  randomizationCompleted: 'Randomizasyon tamamlandı mı?',
  drugAccountability: 'İlaç hesap verebilirliği yapıldı mı?',
  safetyAssessment: 'Güvenlik değerlendirmesi yapıldı mı?',
  queryResolution: 'Query çözümü yapıldı mı?',
  protocolDeviation: 'Protokol sapması var mı?',
  saeReporting: 'SAE raporlaması yapıldı mı?',
  dataEntryCompleted: 'Veri girişi tamamlandı mı?',
  sourceDocumentVerification: 'Kaynak doküman doğrulaması yapıldı mı?',
  monitoringVisitCompleted: 'Monitörleme ziyareti tamamlandı mı?',
  regulatoryDocumentsUpdated: 'Düzenleyici dokümanlar güncellendi mi?',
  siteFileUpdated: 'Site dosyası güncellendi mi?',
  trainingCompleted: 'Eğitim tamamlandı mı?',
  delegationLogUpdated: 'Delegasyon logu güncellendi mi?',
  temperatureLogChecked: 'Sıcaklık logu kontrol edildi mi?',
  pharmacyVisit: 'Eczane ziyareti yapıldı mı?',
  labCertificatesReviewed: 'Laboratuvar sertifikaları gözden geçirildi mi?',
  cvUpdated: 'CV güncellendi mi?',
  licenseVerified: 'Lisans doğrulandı mı?',
  facilityInspection: 'Tesis denetimi yapıldı mı?',
  equipmentCalibration: 'Ekipman kalibrasyonu yapıldı mı?',
  storageConditionsVerified: 'Saklama koşulları doğrulandı mı?',
  shippingDocumentsReviewed: 'Kargo dokümanları gözden geçirildi mi?',
  temperatureExcursionReported: 'Sıcaklık sapması rapor edildi mi?',
  inventoryReconciliation: 'Envanter mutabakatı yapıldı mı?',
  wastageDocumented: 'Fire belgelendi mi?',
  returnShipmentArranged: 'İade kargolama ayarlandı mı?',
  destructionDocumented: 'İmha belgelendi mi?',
  archivingCompleted: 'Arşivleme tamamlandı mı?',
  closeoutVisitScheduled: 'Kapanış ziyareti planlandı mı?',
  finalReportSubmitted: 'Final rapor sunuldu mu?',
  paymentProcessed: 'Ödeme işlendi mi?',
  feedbackCollected: 'Geri bildirim toplandı mı?',
  lessonsLearnedDocumented: 'Öğrenilen dersler belgelendi mi?'
};

/** Firestore zaman damgası → 'tr-TR' tarih/saat (Excel için). */
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return "-";
  if (timestamp.seconds) {
    return new Date(timestamp.seconds * 1000).toLocaleString('tr-TR');
  }
  return timestamp;
};
